import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'sume-form-tab',
    templateUrl: './tab.component.html',
})
export class TabComponent implements OnInit {
    @Input() title: string;
    @Input() hidden = false;
    @Input() alert = false;
    active = false;

    constructor() {}

    ngOnInit(): void {}
}
